import React, { useState, useContext, useRef, useEffect } from "react"
import trcss from "../../../styles/Telerecovery.module.css"

// Context
import { UserContext } from "../../../context/userContext"

// Comps
import CallHistory from "./CallHistory"
import AudioSessionTimer from "./AudioSessionTimer"
import { Button } from "primereact/button"
import { trApiAudioGetCallHistory, trApiGetTwilioAudioToken } from "../telerecoveryApi"
import { Toast } from "primereact/toast"
import CallErrorPopup from "../AlertPopup"
import { formatDate } from "../Utils"
import isParticipantActive from "../../../helpers/isParticipantActive"

export default function TRAudioIndex(props) {
  const userCtx = useContext(UserContext)
  const {
    setAudioToken,
    callStatus,
    isOnCall,
    isDeviceReady,
    isMuted,
    setStartCallEvent,
    setHangupEvent,
    setMuteOnOffEvent,
    callError,
    showCarrierBlockCallError,
    setShowCarrierBlockCallError
  } = userCtx.call

  const [callHistory, setCallHistory] = useState()
  const [loadingCallHistory, setLoadingCallHistory] = useState(false)
  const toast = useRef(null)

  const isParticipantInactive = !isParticipantActive(userCtx.participant_membership_status)

  useEffect(() => {
    getToken()
  }, [userCtx.incomingCall_EventId])

  useEffect(() => {
    getCallHistory()
  }, [userCtx.current_participant_id])

  useEffect(() => {
    if (!isOnCall) {
      getCallHistory()
    }
  }, [isOnCall])

  const getToken = () => {
    trApiGetTwilioAudioToken(userCtx.tokenTelerecovery, userCtx.session.user.staff_id).then(
      (response) => {
        if (response.token) {
          let token = response.token
          setAudioToken(token)
        }
      },
      (err) => console.log(err)
    )
  }

  const callParticipant = () => {
    if (!isOnCall) {
      var params = {
        phoneNumber: userCtx.participant_phone_primary,
        toClient: props.staffNumber, // Caller ID
        callFromPlatform: true,
        participantName: userCtx.participant_name_first +
          " " +
          userCtx.participant_name_last
      }
      setStartCallEvent(params) // Trigger the start call event
    }
  }

  const hangup = () => {
    setHangupEvent(true) // Trigger the hangup event
    getCallHistory()
  }

  const muteOnOff = () => {
    setMuteOnOffEvent(true) // Trigger the mute/unmute event
  }

  const getCallHistory = () => {
    setLoadingCallHistory(true)
    trApiAudioGetCallHistory(userCtx.tokenTelerecovery, props.staffNumber, userCtx.participant_phone_primary).then(
      (response) => {
        let callHistoryAux = []

        Array.from(response).forEach((call) => {
          let direction = ""

          if (call.from === props.staffNumber) {
            direction = "Outbound"
          } else {
            direction = "Inbound"
          }

          callHistoryAux.push({
            date: formatDate(call.dateCreated, "MMMM dd yyyy"),
            time: formatDate(call.dateCreated, "h:mm:ss a"),
            duration: call.duration + " seconds",
            direction: direction,
            errorMessage: call.errorMessage,
            errorCode: call.errorCode,
          })
        })
        setLoadingCallHistory(false)
        setCallHistory(callHistoryAux)
      },
      (err) => {
        setLoadingCallHistory(false)
        console.log(err)
      }
    )
  }

  if (!userCtx.participant_phone_primary) {
    return (
      <span>
        The participant does not have a primary phone number, which is
        required for the SMS feature.
      </span>
    )
  }

  return (
    <>
      <Toast ref={toast} />
      <div style={{ backgroundColor: "white" }}>
        <div
          style={{
            margin: "10px",
            width: "100%",
          }}
        >
          {props.staffNumber && (
            <CallHistory
              callHistory={callHistory}
              staffNumber={props.staffNumber}
              participantPhoneNumber={userCtx.participant_phone_primary}
              loading={loadingCallHistory}
              refresh={getCallHistory}
            />
          )}
        </div>

        {props.isOkaytoContactByPhone === false &&
          <div className={trcss.consent_message} style={{ marginLeft: "9px" }}>
            <i className="pi pi-exclamation-triangle" style={{ fontSize: "24px", color: "#873CAA" }} />
            <div>
              <p style={{ fontWeight: "bold" }}>The participant has not consented to being contacted via phone calls</p>
              <p>Please update their contact information if you would like to be able to make calls</p>
            </div>
          </div>}

        <div style={{ margin: "10px", textAlign: "center" }}>
          <button
            className="btn startAudioCallBtn"
            onClick={() => {
              if (isOnCall)
                hangup()
              else
                callParticipant()
            }}
            style={{ marginTop: "20px" }}
            disabled={!isDeviceReady || props.isOkaytoContactByPhone === false ||
              (!isOnCall && isParticipantInactive)}
          >
            {isOnCall ? "Hangup" : "Start Audio Call"}
          </button>
          {isOnCall && isMuted === false && (
            <Button
              icon="pi pi-volume-up"
              style={{
                marginLeft: "10px",
                marginBottom: "4px",
                padding: "9px 20px",
                zIndex: "9",
                backgroundColor: "#8467ad",
              }}
              onClick={() => muteOnOff()}
            />
          )}
          {isOnCall && isMuted === true && (
            <Button
              icon="pi pi-volume-up"
              style={{
                marginLeft: "10px",
                zIndex: "9",
                marginBottom: "4px",
                padding: "9px 20px",
                backgroundColor: "brown",
                borderColor: "brown",
              }}
              onClick={() => muteOnOff()}
            />
          )}
        </div>
        <div style={{ margin: "10px", textAlign: "center", color: "red" }}>
          <CallErrorPopup
            showPopup={showCarrierBlockCallError}
            setShowPopup={setShowCarrierBlockCallError}
          />
          {!showCarrierBlockCallError && callError}
        </div>
        <div style={{ margin: "10px", textAlign: "center" }}>{callStatus}</div>
        <div style={{ margin: "10px", textAlign: "center" }}>
          {callStatus === "Call in progress." && (
            <AudioSessionTimer startTime={new Date()}></AudioSessionTimer>
          )}
          {callStatus !== "Call in progress." && (
            <div className="sessionTimer">0:0:00</div>
          )}
        </div>
      </div>
    </>
  )
}